export default "__VITE_ASSET__BSHxEilm__"